import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWallet as useMatchIdWallet } from '@matchain/matchid-sdk-react/hooks';
import { WalletClient } from 'viem';

import { setWalletClient } from 'modules/api/walletClient';

import {
  selectConnectionType,
  setConnectionKey,
} from '../store/connectionSlice';
import { getCreateWalletClientParams } from '../utils/getCreateWalletClientParams';
import {
  SELECTED_CONNECTION_TYPE,
  useMatchIdConnection,
} from './useMatchIDConnection';
import { useUpdateConnectionState } from './useUpdateConnectionState';

export function useWatchMatchId(): void {
  const dispatch = useDispatch();

  const { createWalletClient } = useMatchIdWallet();
  const createWalletClientRef = useRef(createWalletClient);
  createWalletClientRef.current = createWalletClient;

  const connectionType = useSelector(selectConnectionType);

  const {
    isConnected,
    getWalletKey,
    accountAddress,
    chainId,
    disconnect,
    walletIcon,
  } = useMatchIdConnection();

  useUpdateConnectionState({
    type: SELECTED_CONNECTION_TYPE,
    chainId,
    isConnected,
    accountAddress,
    disconnect,
    walletIcon,
  });

  // update wallet client from matchId
  useEffect(() => {
    if (connectionType !== SELECTED_CONNECTION_TYPE) {
      return;
    }

    if (!isConnected) {
      return;
    }

    const getClient =
      createWalletClientRef?.current &&
      (() =>
        createWalletClientRef.current(
          getCreateWalletClientParams(),
        ) as WalletClient);
    if (!getClient) {
      return;
    }

    setWalletClient(getClient);
    dispatch(
      setConnectionKey({ type: SELECTED_CONNECTION_TYPE, key: getWalletKey() }),
    );
  }, [connectionType, isConnected, getWalletKey, dispatch]);
}
